import { LoaderActions } from '@store/loaders'
import { call, put } from 'redux-saga/effects'

import { NestClient } from '@/nest'
import { SetSubscriptionAction } from '../actions'
import type { SubscriptionState } from '../types'

export function* fetchSubscription() {
  yield put(LoaderActions.set('subscription_fetch'))

  try {
    const data: SubscriptionState = yield call(NestClient.subscription.my)

    yield put(SetSubscriptionAction(data))
  } catch (err) {
    console.error('Cannot fetch subscription', err)
  } finally {
    yield put(LoaderActions.unset('subscription_fetch'))
  }
}
